import { WaBroadcastService } from '@/services';
import { httpClientOmni } from "@/libraries";

const Types = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    SET_LIMIT_STATUS: 'SET_LIMIT_STATUS',
    SET_LIMIT_REMAINING: 'SET_LIMIT_REMAINING',
    SET_LIMIT_IS_BLOCK: 'SET_LIMIT_IS_BLOCK',
    SET_FORM: 'SET_FORM'
};

const state = {
    data: [],
    error: null,
    loading: false,
    limitStatus: "",
    limitRemaining: "",
    limitIsBlock: false,
    form: {
        templateName: '',
        template: {},
        scheduleDate: null,
        scheduleTime: null,
        targetRecipient: '',
        recipients: [],
        inputParams: [],
        description: '',
        integrationId: '',
        sentVia: 'platform',
        broadcastName: '',
        headerUrl: '',
        scheduleAt: '',
        channelId: 4,
        isDynamicCSVParam: false,
        dynamicCSVParam: [],
        sendNow: false,
        header: null,
        footer: null,
        button: null,
        dynamicUrlParam: '',
        dynamicHeaderText: '',
        groupId: null,
        sent_by: '',
        batch: []
    }
};

const getters = {
    loading: (state) => state.loading,
    error: (state) => state.error,
    limitStatus: (state) => state.limitStatus,
    limitRemaining: (state) => state.limitRemaining,
    limitIsBlock: (state) => state.limitIsBlock,
    form: (state) => state.form,
};

const mutations = {
    [Types.SET_LOADING]: (state, payload) => (state.loading = payload),
    [Types.SET_ERROR]: (state, payload) => (state.error = payload),
    [Types.SET_LIMIT_STATUS]: (state, payload) => (state.limitStatus = payload),
    [Types.SET_LIMIT_REMAINING]: (state, payload) => (state.limitRemaining = payload),
    [Types.SET_LIMIT_IS_BLOCK]: (state, payload) => (state.limitIsBlock = payload),
    [Types.SET_FORM]: (state, payload) => (state.form = payload)
};

const actions = {
    async createBroadcast({ commit }, payload) {
        commit(Types.SET_LOADING, true);
        try {
            const response = await WaBroadcastService.createBroadcast(payload);
            return response;
        } catch (error) {
            commit(Types.SET_ERROR, error);
        }
        commit(Types.SET_LOADING, false);
    },
    async fetchLimit({ commit }, payload) {
      commit(Types.SET_LIMIT_STATUS, "Clear");
        const check = await httpClientOmni.post(
          `limit-configuration/limit-usage`,
          {
            integration_id: payload.integrationId,
            configuration_type: "Whatsapp Broadcast",
            template_id: payload.templateId,
          }
        );

        const response = check.data;
        if (response.data) {
          commit(Types.SET_LIMIT_STATUS, response.data.status);
          commit(Types.SET_LIMIT_REMAINING, response.data.remaining);
          commit(
            Types.SET_LIMIT_IS_BLOCK,
            response.data.is_block_when_limit_reached
          );
        }
    },
    async deleteBroadcast({ commit }, payload) {
        commit(Types.SET_LOADING, true);
        try {
            const response = await WaBroadcastService.deleteBroadcast(payload);
            return response;
        } catch (error) {
            commit(Types.SET_ERROR, error);
        }
        commit(Types.SET_LOADING, false);
    },
    async editBroadcast({ commit }, payload) {
        commit(Types.SET_LOADING, true);
        try {
            const response = await WaBroadcastService.editBroadcast(payload);
            return response;
        } catch (error) {
            commit(Types.SET_ERROR, error);
        }
        commit(Types.SET_LOADING, false);
    },
    async exportCsv({ commit }, payload) {
        commit(Types.SET_LOADING, true);
        try {
            const response = await WaBroadcastService.exportCsv(payload);
            return response;
        } catch (error) {
            console.log('error export csv', error);
            commit(Types.SET_ERROR, error);
        }
        commit(Types.SET_LOADING, false);
    },
    async exportPdf({ commit }, payload) {
        commit(Types.SET_LOADING, true);
        try {
            const response = await WaBroadcastService.exportPdf(payload);
            return response;
        } catch (error) {
            console.log('error export pdf', error);
            commit(Types.SET_ERROR, error);
        }
        commit(Types.SET_LOADING, false);
    },
    watchForm({ commit }, payload) {
        commit(Types.SET_FORM, payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
